"use client";

import { useGSAP } from "@gsap/react";
import clsx from "clsx";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useRef } from "react";
import { useApp } from "@/context/AppContext";


export default function Reveal({ children, className = "", tag = "div" }) {
  const { ready, getTransitionReady, isMobile } = useApp()

  const root = useRef(null)
  const Tag = tag

  gsap.registerPlugin(ScrollTrigger)
  gsap.registerPlugin(useGSAP)


  const animateIn = async () => {
    await ready;
    await getTransitionReady();

    gsap.killTweensOf(root.current);

    root.current.classList.add("is-revealed");

    gsap.to(root.current, {
      opacity: 1,
      duration: 0.3
    })

    gsap.to(root.current, {
      y: '0%',
      duration: 1.2,
      ease: 'expo.out'
    })
  }

  const animateOut = async () => {
    await ready;

    gsap.killTweensOf(root.current);

    root.current.classList.remove("is-revealed");

    gsap.to(root.current, {
      opacity: 0,
      duration: 0.3
    })

    gsap.to(root.current, {
      y: '50%',
      duration: 1.2,
      ease: 'expo.out'
    })
  }

  useGSAP(() => {
    const mm = gsap.matchMedia();

    mm.add(
      {
        hasMotion: "(prefers-reduced-motion: no-preference)",
        hasNoMotion: "(prefers-reduced-motion: reduce)",
      },
      (context) => {
        const { hasMotion, hasNoMotion } = context.conditions;

        if (hasMotion) {
          gsap.set(root.current, {
            y: '50%'
          })

          ScrollTrigger.create({
            trigger: root.current,
            onEnter: animateIn,
            onLeaveBack: animateOut,
            start: 'top bottom'
          })
        } else if (hasNoMotion) {
          gsap.set(root.current, {
            opacity: 1,
            y: '0%'
          })
        }
      }
    )

    return () => mm.revert();
  }, [isMobile])



  return (
    <Tag ref={root} className={clsx(className, 'opacity-0 will-change-transform')}>
      {children}
    </Tag>
  )
}